import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { RoutesList } from '../../../config/routes-list';
import { WizardLayout } from '../register/wizard-layout';

export function ItemNotFoundAlert() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <WizardLayout>
      <Alert severity="error">{t('goodsReceiving.itemNotFound')}</Alert>
      <Button onClick={() => navigate(RoutesList.GOODS_RECEIVING_REGISTER_ITEMS)} sx={{ mt: 2 }}>
        {t('goodsReceiving.backToItems')}
      </Button>
    </WizardLayout>
  );
}
